import { useApiData } from '../useApiData';
import { setPublicMenu } from 'store/publicMenu/actions';

export const usePublicMenuApi = () => {
    useApiData('/demo-dishlists', ({ dishlist }) => setPublicMenu(dishlist), {
        params: { provider_id: 1 },
    });
};
